var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ClinicalForm',{attrs:{"form-key-prefix":"visit","title":'Patient Data Collection',"chapter":_vm.chapter}})
}
var staticRenderFns = []

export { render, staticRenderFns }